import { trackPromise } from "react-promise-tracker";
import { fetchWithTimeout } from "./BaseAPI";
import { getAccessToken } from "context/AuthContext";
import User from "context/User";

const baseUrlAPI = process.env.REACT_APP_U_API_URL;

async function requestHeaders() {
    const accessToken = await getAccessToken(User.VERITAS);

    const requestHeaders = new Headers();
    requestHeaders.append('Accept', 'application/json');
    requestHeaders.append('Content-Type', 'application/json');
    if (accessToken) {
        requestHeaders.append("jwtToken", `${accessToken}`);
    }
    return requestHeaders;
}

export async function statisticsDash() {
    const url = `${baseUrlAPI}/admin/statistics/dash`;
    const response = await trackPromise(fetchWithTimeout(url, {
        headers: await requestHeaders()
    }));
    return await response.json();
}

export async function statisticsOverview() {
    const url = `${baseUrlAPI}/admin/statistics/overview`;
    const response = await trackPromise(fetchWithTimeout(url, {
        headers: await requestHeaders()
    }));
    return await response.json();
}

export async function statisticsUsers() {
    const url = `${baseUrlAPI}/admin/statistics/users`;
    const response = await trackPromise(fetchWithTimeout(url, {
        headers: await requestHeaders()
    }));
    return await response.json();
}

export async function statisticsOrigin() {
    const url = `${baseUrlAPI}/admin/statistics/origin`;
    const response = await trackPromise(fetchWithTimeout(url, {
        headers: await requestHeaders()
    }));
    return await response.json();
}
